// extracted by mini-css-extract-plugin
export default {"settingsMenu":"SettingsMenu_settingsMenu__zxcJG","wash":"SettingsMenu_wash__MbnOt","menu":"SettingsMenu_menu__sNM2c","separator":"SettingsMenu_separator__f8jB-"};